var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forum-item"},[_c('div',{staticClass:"forum-icon"},[_c('img',{attrs:{"src":_vm.data.imgUrl}})]),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.data.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }